import { render, staticRenderFns } from "./empleados.vue?vue&type=template&id=7febb4e2&scoped=true"
import script from "./empleados.vue?vue&type=script&lang=js"
export * from "./empleados.vue?vue&type=script&lang=js"
import style0 from "./empleados.vue?vue&type=style&index=0&id=7febb4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7febb4e2",
  null
  
)

export default component.exports